export interface RadioProps {
  value: string;
  checked: boolean;
  onChange: () => void;
  label: string;
  disabled?: boolean;
}

export interface RadioGroupProps {
  value: string;
  onChange: (value: string) => void;
  options: Array<{ value: string; label: string; disabled?: boolean }>;
  direction?: 'horizontal' | 'vertical';
}

export function Radio({ value, checked, onChange, label, disabled = false }: RadioProps) {
  return (
    <label
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '8px',
        cursor: disabled ? 'not-allowed' : 'pointer',
        opacity: disabled ? 0.5 : 1,
        userSelect: 'none',
      }}
    >
      <span
        style={{
          position: 'relative',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: '16px',
          height: '16px',
          flexShrink: 0,
        }}
      >
        <input
          type="radio"
          checked={checked}
          onChange={onChange}
          disabled={disabled}
          value={value}
          style={{ position: 'absolute', opacity: 0, width: 0, height: 0, margin: 0 }}
        />
        <span
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '16px',
            height: '16px',
            borderRadius: '50%',
            border: `1.5px solid ${checked ? 'var(--evo-cyan)' : 'var(--evo-fg-3)'}`,
            background: 'transparent',
            transition: 'border-color 120ms linear',
            boxSizing: 'border-box',
            flexShrink: 0,
          }}
        >
          {checked && (
            <span
              style={{
                width: '8px',
                height: '8px',
                borderRadius: '50%',
                background: 'var(--evo-cyan)',
                flexShrink: 0,
              }}
            />
          )}
        </span>
      </span>
      <span
        style={{
          fontSize: '13px',
          color: 'var(--evo-fg-2)',
          fontFamily: 'var(--evo-font)',
          lineHeight: 1,
        }}
      >
        {label}
      </span>
    </label>
  );
}

export function RadioGroup({ value, onChange, options, direction = 'vertical' }: RadioGroupProps) {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: direction === 'horizontal' ? 'row' : 'column',
        gap: direction === 'horizontal' ? '16px' : '10px',
        flexWrap: direction === 'horizontal' ? 'wrap' : 'nowrap',
      }}
    >
      {options.map(opt => (
        <Radio
          key={opt.value}
          value={opt.value}
          checked={value === opt.value}
          onChange={() => onChange(opt.value)}
          label={opt.label}
          disabled={opt.disabled ?? false}
        />
      ))}
    </div>
  );
}
